exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Space{min-height:1px}.Space--horizontal{display:inline-block}", ""]);

